import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-campaign-group-sequence-experiment',
  imports: [],
  templateUrl: './campaign-group-sequence-experiment.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './campaign-group-sequence-experiment.component.css'
})
export class CampaignGroupSequenceExperimentComponent {

}
